//------------------------------------------------------------------------------
// 電柱選択
//------------------------------------------------------------------------------
import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import Grid from '@mui/material/Grid';
import Tooltip from '@mui/material/Tooltip';
import { PositiveButton } from '@/components/atoms/Buttons/PositiveButton';
import { renderTextField } from '@/components/atoms/CustomPart';
import { requiredValue } from '@/components/validateRule';
import AreaSelectField from '@/components/area-field';
import LineSelectField from '@/components/line-field';

/**
 * 電柱検索パネル
 */
export default function PoleSearchPanel({
  values,
  change,
  onSearch,
  handleSubmit,
}) {

  // 地区コード選択処理
  const handleAreaChange = React.useCallback(() => {
    change('line', '');  // 線路コードをクリア
  }, [change]);

  // 電柱検索ボタン処理
  const handleSearch = React.useCallback((formValues) => {
    const searchValues = {
      area: formValues.area?.value || null,  // 地区コード
      line: formValues.line?.value || null,  // 線路コード

      // 電柱番号 (線路コード設定時のみ有効)
      pole: formValues.line?.value ? formValues?.pole : null,
    };
    onSearch(searchValues);
  }, [onSearch]);

  //
  // 描画
  //
  return (
    <Grid container spacing={2}>

      {/* 地区コード選択 */}
      <Grid item sx={{ width: '12rem' }}>
        <AreaSelectField
          name="area" label="地区"
          onChange={handleAreaChange}
          required validate={[ requiredValue ]}
        />
      </Grid>

      {/* 線路コード選択 */}
      <Grid item sx={{ width: '13rem' }}>
        <LineSelectField
          name="line" label="冠称"
          areaCode={values?.area?.value}
        />
      </Grid>

      {/* 電柱番号 - 前方一致 */}
      <Grid item sx={{ width: '12rem' }}>
        <Tooltip title="前方一致で検索します"
          arrow placement="top"
          disableHoverListener
        >
          <div>
            <Field name="pole" label="電柱番号"
              component={renderTextField}
              disabled={!values?.line?.value}
              fullWidth variant="standard" size="small"
              inputProps={{ maxLength: 12 }}
            />
          </div>
        </Tooltip>
      </Grid>

      {/* 電柱検索ボタン */}
      <Grid item
        sx={{
          display: 'flex',
          alignItems: 'center'
        }}
      >
        <PositiveButton type="submit"
          variant="contained" size="midium"
          onClick={handleSubmit(handleSearch)}
        >
          電柱検索
        </PositiveButton>
      </Grid>
    </Grid>
  );
}

// プロパティ
PoleSearchPanel.propTypes = {

  // 検索処理
  onSearch: PropTypes.func.isRequired,

  // フォーム
  values: PropTypes.object,
  change: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
};
